// @flow

import { useMemo } from 'react';

import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { type Feature } from '@tectonics/prs/feature';
import { usePaymentSpec } from './context-use';
import { getPaymentMethodByCode } from './get-payment-method';

export function useCurrentAllFeatures(): ImmutableArray<Feature> {
  const spec = usePaymentSpec();
  const [selectedPaymentMethodCode] = useUserInputValue('selectedPaymentMethod');
  const selectedPaymentMethod = getPaymentMethodByCode(selectedPaymentMethodCode, spec);

  return useMemo(() => [
    ...spec.features,
    ...(selectedPaymentMethod ? selectedPaymentMethod.features : []),
  ], [spec, selectedPaymentMethod]);
}
